var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 98,
    viewBox: "0 0 153 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 130,
    height: 75,
    rx: 3,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97 2H128C129.105 2 130 2.89543 130 4V73C130 74.1046 129.105 75 128 75H97V2Z",
    fill: "#EC9770"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 1,
    width: 2,
    height: 74,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 16,
    width: 21,
    height: 1,
    rx: 0.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 20,
    width: 21,
    height: 1,
    rx: 0.5,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 24,
    width: 21,
    height: 1,
    rx: 0.5,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 28,
    width: 17,
    height: 1,
    rx: 0.5,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 45,
    width: 17,
    height: 6,
    fill: "#624AB6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 15,
    width: 58,
    height: 4,
    rx: 2,
    fill: "#8D4DC9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 49,
    width: 58,
    height: 4,
    rx: 2,
    fill: "#8D4DC9",
    fillOpacity: 0.2
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 60,
    width: 58,
    height: 4,
    rx: 2,
    fill: "#8D4DC9",
    fillOpacity: 0.2
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 24,
    width: 47,
    height: 1,
    fill: "#EC9770"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 30,
    width: 47,
    height: 1,
    fill: "#EC9770"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 36,
    width: 47,
    height: 1,
    fill: "#EC9770"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 42,
    width: 47,
    height: 1,
    fill: "#EC9770"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 76.5,
    r: 21.5,
    fill: "#E9706D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.513 87H138.751V84.2021H128.98V83.9092L133.463 79.4414C137.301 75.6328 138.414 73.7871 138.414 71.3848V71.3408C138.414 67.8545 135.514 65.3496 131.573 65.3496C127.325 65.3496 124.337 68.0742 124.322 71.9414L124.352 71.9707H127.428L127.442 71.9268C127.442 69.6123 129.024 68.0596 131.397 68.0596C133.712 68.0596 135.133 69.583 135.133 71.6484V71.6924C135.133 73.4062 134.327 74.4902 131.529 77.4053L124.513 84.7734V87Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step_2.c6cb9ee62a9024b234208d3f2e239efb.svg";
export { ForwardRef as ReactComponent };